import { useAdPlacementTypeValuesQuery } from 'data/generated/graphql';

export const useAdPlacementTypeValues = () => {
  const { data, isLoading, error } = useAdPlacementTypeValuesQuery();

  return {
    adPlacementTypeValues: data?.adPlacementTypeValues ?? [],
    loading: isLoading,
    error
  };
};
